import Web2CaseInput from '@/components/Forms/Web2CaseForm/components/input';
import { SF_INPUT_ID } from '@/components/Forms/Web2CaseForm/config/sfInput';

type Props = {
  productLabel: string;
  lotLabel: string;
  codeLabel: string;
};

const ProductComplaintFields = ({ productLabel, lotLabel, codeLabel }: Props) => {
  return (
    <div className="space-y-8">
      <Web2CaseInput label={productLabel} maxLength={255} name="product_name" type="text" />
      <Web2CaseInput label={lotLabel} maxLength={255} name="lot_code" type="text" />
      <Web2CaseInput label={codeLabel} maxLength={255} name={SF_INPUT_ID.BAR_CODE} type="text" />
    </div>
  );
};

export default ProductComplaintFields;
